import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function EventsSection() {
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5001';

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/events`);
        if (!res.ok) return;
        const data = await res.json();
        setEvents(data || []);
      } catch (err) {
        console.error('Failed to fetch events:', err);
        setEvents([]);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  const formatDay = (iso?: string) => {
    if (!iso) return ['--', ''];
    const d = new Date(iso);
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString(undefined, { month: 'short' });
    return [day, month];
  };

  return (
    <section className="py-20" style={{ backgroundColor: '#f8fafc' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Left - Events List */}
          <div className="flex-1">
            <div className="flex items-center justify-between mb-8">
              <div>
                <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700 mb-2 block">Live Sessions</span>
                <h2 className="text-3xl font-extrabold text-slate-800" style={{ fontFamily: "'Inter', sans-serif" }}>Upcoming Events</h2>
              </div>
              <Link to="/events" className="hidden sm:flex items-center gap-1 text-sm font-medium text-emerald-700 hover:text-emerald-800 transition-colors cursor-pointer whitespace-nowrap">
                View all <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="flex flex-col gap-3">
              {loading && <div className="text-slate-400 text-sm">Loading events...</div>}
              {!loading && events.length === 0 && <div className="text-slate-400 text-sm">No upcoming events</div>}

              {events.map((event) => {
                const [day, month] = formatDay(event.date);
                return (
                  <div key={event._id || event.id} className="bg-white border border-slate-100 rounded-xl p-4 flex items-center gap-4 hover:border-emerald-200 transition-all cursor-pointer group">
                    <div className="w-14 h-14 flex-shrink-0 flex flex-col items-center justify-center bg-emerald-700 rounded-xl text-white">
                      <span className="text-xl font-bold leading-none" style={{ fontFamily: "'Inter', sans-serif" }}>{day}</span>
                      <span className="text-xs font-medium opacity-90">{month}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        {event.category ? (
                          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${event.category === 'GCSE' ? 'bg-emerald-50 text-emerald-700' : 'bg-violet-50 text-violet-700'}`}>{event.category}</span>
                        ) : event.categories && event.categories.length > 0 ? (
                          event.categories.map((c: string) => (
                            <span key={c} className={`text-xs font-semibold px-2 py-0.5 rounded-full ${c === 'GCSE' ? 'bg-emerald-50 text-emerald-700' : 'bg-violet-50 text-violet-700'}`}>{c}</span>
                          ))
                        ) : (
                          event.level && <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${event.level === 'GCSE' ? 'bg-emerald-50 text-emerald-700' : 'bg-violet-50 text-violet-700'}`}>{event.level}</span>
                        )}
                      </div>
                      <p className="text-slate-800 font-semibold text-sm truncate group-hover:text-emerald-700 transition-colors">{event.title}</p>
                      <div className="flex items-center gap-3 mt-1">
                        <span className="flex items-center gap-1 text-slate-400 text-xs"><i className="ri-time-line"></i>{event.time}</span>
                        <span className="flex items-center gap-1 text-slate-400 text-xs"><i className="ri-map-pin-line"></i>{event.location || 'Online'}</span>
                      </div>
                    </div>
                    <div className="w-8 h-8 flex items-center justify-center text-slate-300 group-hover:text-emerald-600 transition-colors">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                );
              })}
            </div>

            <Link to="/events" className="sm:hidden mt-4 flex items-center justify-center gap-1 text-sm font-medium text-emerald-700 cursor-pointer">
              View all events <i className="ri-arrow-right-line"></i>
            </Link>
          </div>


        </div>
      </div>
    </section>
  );
}
